<div class="modal-dialog-container">
  <div class="dialog-content">
    <div class="modal-dialog-header">
      <button id="btn-fermer-popup" class="dialog-close-button" [mat-dialog-close]>
        <img
          src="{{ 'assets/images/icone-close.svg' | cheminAbsoluStatique }}"
          alt="{{ 'btn.fermer' | translate }}"
          width="15"
          height="15"
          class="close-icon"
        />
      </button>
      <h1 class="dialog-title" id="titre-infobulle">
        {{ titre }}
      </h1>
    </div>

    <div class="modal-dialog-body ">
      <p id="texte-infobulle" [innerHTML]="texte"></p>
    </div>
  </div>
</div>
